import { lazy } from "react";

export const ModulesDictionaries = lazy(() => import("./modules-dictionaries"));
export { DICTIONARY_LIST_PATH } from "./modules-dictionaries-path";
